// @flow

import {havePermission} from "./utils"

export default class AdminPermissions {

  isAdmin(proRole:ProRole = null): boolean {
    return havePermission(
      'admin',
      proRole
    );
  }
}
